import { render, staticRenderFns } from "./BillApplyShipments.vue?vue&type=template&id=2dcde25a&scoped=true"
import script from "./BillApplyShipments.vue?vue&type=script&lang=js"
export * from "./BillApplyShipments.vue?vue&type=script&lang=js"
import style0 from "./BillApplyShipments.vue?vue&type=style&index=0&id=2dcde25a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcde25a",
  null
  
)

export default component.exports